<template>
  <div>
    <b-card>
      <validation-observer ref="observer">
        <b-form>
          <b-row>
            <!-- Logo -->
            <b-col cols="12">
              <b-form-group label="Logo Perusahaan">
                <!-- Preview di atas -->
                <div
                  v-if="previewLogo"
                  class="mb-2"
                >
                  <label class="d-block font-weight-bold">Preview Logo</label>
                  <img
                    :src="previewLogo"
                    alt="Preview Logo"
                    class="img-thumbnail shadow"
                    style="max-height: 150px; border-radius: 8px;"
                  >
                </div>

                <!-- Input file di bawah -->
                <b-form-file
                  v-model="file"
                  accept="image/*"
                  placeholder="Pilih logo perusahaan"
                  browse-text="Pilih Logo"
                  drop-placeholder="Tarik dan lepas file di sini"
                />
              </b-form-group>
            </b-col>
            <!-- Nama Perusahaan -->
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="Nama Perusahaan"
                label-for="name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="form.name"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Masukkan nama perusahaan"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Email -->
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="Email"
                label-for="email"
              >
                <b-form-input
                  id="email"
                  v-model="form.email"
                  type="email"
                  placeholder="Email"
                />
              </b-form-group>
            </b-col>

            <!-- Phone -->
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="Telepon"
                label-for="phone"
              >
                <b-form-input
                  id="phone"
                  v-model="form.phone"
                  placeholder="Nomor Telepon"
                />
              </b-form-group>
            </b-col>

            <!-- Website -->
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="Website"
                label-for="website"
              >
                <b-form-input
                  id="website"
                  v-model="form.website"
                  placeholder="https://contoh.com"
                />
              </b-form-group>
            </b-col>

            <!-- Alamat -->
            <b-col cols="12">
              <b-form-group
                label="Alamat"
                label-for="address"
              >
                <b-form-textarea
                  id="address"
                  v-model="form.address"
                  placeholder="Alamat perusahaan"
                  rows="2"
                />
              </b-form-group>
            </b-col>

            <!-- Deskripsi -->
            <b-col cols="12">
              <b-form-group
                label="Deskripsi"
                label-for="desc"
              >
                <b-form-textarea
                  id="desc"
                  v-model="form.desc"
                  placeholder="Deskripsi perusahaan"
                  rows="2"
                />
              </b-form-group>
            </b-col>

            <!-- Footer Note -->
            <b-col cols="12">
              <b-form-group
                label="Catatan Footer"
                label-for="footer_note"
              >
                <b-form-input
                  id="footer_note"
                  v-model="form.footer_note"
                  placeholder="© 2025 Company. All rights reserved."
                />
              </b-form-group>
            </b-col>
            <!-- Tombol -->
            <b-col
              cols="12"
              class="text-right"
            >
              <b-button
                variant="success"
                @click.prevent="submitForm"
              >
                Simpan
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {
  BForm, BFormInput, BFormGroup, BRow, BCol, BCard,
  BFormTextarea, BFormFile, BButton,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BFormTextarea,
    BFormFile,
    BButton,
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        phone: '',
        website: '',
        address: '',
        desc: '',
        footer_note: '',
        img_logo: '',
      },
      file: null,
      previewLogo: '',
      required,
    }
  },
  watch: {
    file(newFile) {
      if (newFile) {
        const reader = new FileReader()
        reader.onload = e => {
          this.previewLogo = e.target.result
        }
        reader.readAsDataURL(newFile)
      }
    },
  },
  created() {
    this.loadCompany()
  },
  methods: {
    loadCompany() {
      this.$http.get('/company') // sesuaikan dengan route API-mu
        .then(res => {
          this.form = { ...res.data.data }
          this.previewLogo = `${process.env.VUE_APP_API_BASE_URL}/../../images/${this.form.img_logo}`
        })
    },
    submitForm() {
      this.$refs.observer.validate().then(success => {
        if (!success) {
          this.$bvToast.toast('Lengkapi data terlebih dahulu.', {
            title: 'Gagal',
            variant: 'danger',
            solid: true,
          })
          return
        }

        const formData = { ...this.form }

        if (this.file) {
          const reader = new FileReader()
          reader.onload = () => {
            formData.img_logo = reader.result
            this.saveToServer(formData)
          }
          reader.readAsDataURL(this.file)
        } else {
          this.saveToServer(formData)
        }
      })
    },
    saveToServer(payload) {
      this.$http.put('/company/update', payload)
        .then(() => {
          this.$bvToast.toast('Data perusahaan berhasil diperbarui.', {
            title: 'Sukses',
            variant: 'success',
            solid: true,
          })
        })
        .catch(err => {
          const message = err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Gagal menyimpan data perusahaan.'

          console.error(err)

          this.$bvToast.toast(message, {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
  },
}
</script>
